var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 15H0.5L0.746235 15.5H13.25L13.5 15H14L13.5 16H0.5L0 15V0H4.86957L6.95652 2.78261L8.22826 2.79347L9 0.804321L11 6.30432H15.5L12 9.80432L14 15ZM9 3.80432L10.25 7.05432H13.5L10.875 9.55432L12.5 12.8043L9 10.8043L5.5 12.8043L7.125 9.55432L4 7.05432H7.75L9 3.80432ZM10.5 1.30432H16V2.30432H11L10.5 1.30432ZM16 4.30432H11.5L12 5.30432H16V4.30432ZM16 8.30432V9.30432H14L15 8.30432H16ZM16 11.3043H13.5L14 12.3043H16V11.3043Z",
    fill: "#0059CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickAccess);
export default __webpack_public_path__ + "static/media/QuickAccess.a90a63812100b56abb8a589e2eb76bfe.svg";
export { ForwardRef as ReactComponent };